import createIcon from '../../createIcon';

/**
 * @component @name SwitchLeft
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOC41IDguNjJWMTUuMzhMNS4xMiAxMkw4LjUgOC42MlpNMTAgNUwzIDEyTDEwIDE5VjVaTTE0IDVWMTlMMjEgMTJMMTQgNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SwitchLeft = createIcon('SwitchLeft', [
  [
    'path',
    {
      d: 'M8.5 8.62V15.38L5.12 12L8.5 8.62ZM10 5L3 12L10 19V5ZM14 5V19L21 12L14 5Z',
      key: '1lxm8c',
    },
  ],
]);

export default SwitchLeft;
